import { useLocation } from 'react-router';
import { styled } from 'styled-components';

import { Button } from '#/components/Button/Button';
import { Pill } from '#/components/Pill/Pill';
import { Tooltip } from '#/components/Tooltip/Tooltip';
import { useI18n } from '#/i18n/hooks/useI18n';
import { SearchRefinementDropdownHolder } from '#/modules/search/components/Refinement/Dropdown/SearchRefinementDropdown.styled';
import { useSearchFacetReset } from '#/modules/search/hooks/facets/useSearchFacetReset';
import { useSearchJobsRouteLoaderData } from '#/modules/search/hooks/useSearchJobsRouteLoaderData';
import { colors, spacing } from '#/theme/theme';

// As of now, this is the only place where the `synonymId` is stored as a filter
// https://github.com/idealist7/idealist7/blob/4afba44021034907e6d4f83589c36dcdfd8669c1/web/src/modals/EmailAlert/EmailAlertModalContainer.tsx#L75
// At some point, this will be converted into a `SearchFacetDropdown`

const SearchFilterCloseButton = styled(Button)`
  div[role='img'] {
    color: ${colors.lightContentGrey};
    margin-left: ${spacing[6]};
    padding: 0;
    position: relative;
    top: -1px;
    left: 3px;
  }
`;

export function JobFamilyFilter() {
  const { i18n } = useI18n();
  const location = useLocation();

  const { jobFamilyId, jobSynonymName } = useSearchJobsRouteLoaderData();

  const resetFacet = useSearchFacetReset('synonymId');

  const selectedFilterValue = location.search.includes('synonymId');

  if (!jobSynonymName || !jobFamilyId || !selectedFilterValue) return null;

  return (
    <SearchRefinementDropdownHolder
      data-facet-state="PINNED"
      data-facet-type="synonymId"
    >
      <Tooltip
        content={i18n(`Similar To: %(jobSynonymName)s`, { jobSynonymName })}
        placement="bottom-center"
        variant="filled"
      >
        <Pill
          size="medium"
          suffix={
            <SearchFilterCloseButton
              qaId="close-banner-ad-button"
              onClick={resetFacet}
              noPadding
              variant="tertiary-grey"
              type="button"
              icon={{
                type: 'normalized',
                name: 'close',
                color: 'lightContentGrey',
                size: 16,
              }}
            />
          }
        >
          <span style={{ whiteSpace: 'nowrap' }}>
            {i18n(`Similar To: %(jobSynonymName)s`, { jobSynonymName })}
          </span>
        </Pill>
      </Tooltip>
    </SearchRefinementDropdownHolder>
  );
}
